import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=214bde92&scoped=true"
import script from "./payroll.vue?vue&type=script&lang=ts"
export * from "./payroll.vue?vue&type=script&lang=ts"
import style0 from "./payroll.vue?vue&type=style&index=0&id=214bde92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214bde92",
  null
  
)

export default component.exports